import { render } from "./Hotspot21.vue?vue&type=template&id=7b952db2&scoped=true&ts=true"
import script from "./Hotspot21.vue?vue&type=script&lang=ts"
export * from "./Hotspot21.vue?vue&type=script&lang=ts"

import "./Hotspot21.vue?vue&type=style&index=0&id=7b952db2&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b952db2"]])

export default __exports__